module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C183"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "C186"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/05_List_of#page_ix"
    }
  }, [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "C184"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Acknowle#page_xi"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter#page_1"
    }
  }, [_vm._v("CHAPTER 1. Timing and Turnout: The Basics")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter#page_16"
    }
  }, [_vm._v("CHAPTER 2. A Theory of Election Timing")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter#page_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 3. Partisan Power Play: Election Timing Politics in the Nineteenth Century")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter#page_81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4. Interest Groups and Election Timing Choice in the Twenty-First Century")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter#page_126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5. Estimating the Effect of Off-Cycle Election Timing: School Board Elections")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter#page_167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6. “What Election?” Timing, Turnout, and Policy in California Cities")])]), _vm._v(" "), _c('p', {
    staticClass: "C184"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter#page_200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7. Implications for Democracy, Representation, and Institutional Stability")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Appendix#page_217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendixes")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#page_235",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Index#page_269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21f80bc3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 66
// module chunks = 0